// @flow
import React from "react"
import type { Component } from "recompose"
import { is, path } from "ramda"
import { Field } from "formik"
import { isEvent } from "common/events"
import InputWrap from "./InputWrap"
import type { ToolTipContent } from "data/tooltips/types"

const handleBlur = props => () => {
  props.form.setFieldTouched(props.field.name, true)
}

const handleChange = props => eventOrValue => {
  const value = isEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue

  props.form.setFieldValue(props.field.name, value)
  props.form.setStatus({ ...props.form.status, error: null })

  if (is(Function, props.onChange)) {
    props.onChange(eventOrValue)
  }
}

type Added<Value> = {
  value: Value,
  onChange: Value => mixed,
  unit: string[] | string,
  // onBlur: void => mixed,
  // error?: ?string,
}

export type ReqOutter = {
  name: string,
  label: string,
  errorPosition?: string,
  toolTip?: ToolTipContent | string,
  noMargin?: boolean,
}

function withField<Outter: ReqOutter, Value>(
  ComposedComponent: Component<{|
    ...$Exact<$Diff<Outter, ReqOutter>>,
    ...$Exact<Added<Value>>,
  |}>,
): Component<Outter> {
  return props => (
    <Field
      {...props}
      render={fieldProps => {
        const showError =
          path(["form", "status", "submitted"], fieldProps) ||
          fieldProps.form.touched[fieldProps.field.name] === true
        const error =
          showError &&
          showError &&
          fieldProps.form.errors[fieldProps.field.name]
        return (
          <InputWrap
            error={error}
            label={props.label}
            errorPosition={props.errorPosition}
            toolTip={props.toolTip}
            noMargin={props.noMargin}
          >
            <ComposedComponent
              {...props}
              {...fieldProps.field}
              // error={error}
              onChange={handleChange({ ...props, ...fieldProps })}
              onBlur={handleBlur({ ...props, ...fieldProps })}
            />
          </InputWrap>
        )
      }}
    />
  )
}

export default withField



// WEBPACK FOOTER //
// ./src/forms/withFormField/index.js